// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/deal.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DealExternalDocument } from "./deal_external_document_pb";
import { file_api_proto_v1_deal_external_document } from "./deal_external_document_pb";
import type { DealMemoResponse } from "./deal_memo_pb";
import { file_api_proto_v1_deal_memo } from "./deal_memo_pb";
import type { CustomerType, Form, FormGroup, FormRequest, FormType, FormValue } from "./form_pb";
import { file_api_proto_v1_form } from "./form_pb";
import type { Order } from "./list_pb";
import { file_api_proto_v1_list } from "./list_pb";
import type { ListValue, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/deal.proto.
 */
export const file_api_proto_v1_deal: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_deal_external_document, file_api_proto_v1_deal_memo, file_api_proto_v1_form, file_api_proto_v1_list, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message api_proto.v1.CreateDealForDocumentRequest
 */
export type CreateDealForDocumentRequest = Message<"api_proto.v1.CreateDealForDocumentRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;
};

/**
 * Describes the message api_proto.v1.CreateDealForDocumentRequest.
 * Use `create(CreateDealForDocumentRequestSchema)` to create a new message.
 */
export const CreateDealForDocumentRequestSchema: GenMessage<CreateDealForDocumentRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 0);

/**
 * @generated from message api_proto.v1.DocumentDealResponse
 */
export type DocumentDealResponse = Message<"api_proto.v1.DocumentDealResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * 案件ステータス（見積/請求一覧での表示用）
   *
   * @generated from field: api_proto.v1.DealStatus status = 3;
   */
  status: DealStatus;
};

/**
 * Describes the message api_proto.v1.DocumentDealResponse.
 * Use `create(DocumentDealResponseSchema)` to create a new message.
 */
export const DocumentDealResponseSchema: GenMessage<DocumentDealResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 1);

/**
 * 詳細
 *
 * @generated from message api_proto.v1.GetDealFormRequest
 */
export type GetDealFormRequest = Message<"api_proto.v1.GetDealFormRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetDealFormRequest.
 * Use `create(GetDealFormRequestSchema)` to create a new message.
 */
export const GetDealFormRequestSchema: GenMessage<GetDealFormRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 2);

/**
 * @generated from message api_proto.v1.GetDealFormGroupsResponse
 */
export type GetDealFormGroupsResponse = Message<"api_proto.v1.GetDealFormGroupsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.FormGroup form_groups = 1;
   */
  formGroups: FormGroup[];
};

/**
 * Describes the message api_proto.v1.GetDealFormGroupsResponse.
 * Use `create(GetDealFormGroupsResponseSchema)` to create a new message.
 */
export const GetDealFormGroupsResponseSchema: GenMessage<GetDealFormGroupsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 3);

/**
 * 簡易作成
 *
 * @generated from message api_proto.v1.GetDealFormsResponse
 */
export type GetDealFormsResponse = Message<"api_proto.v1.GetDealFormsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.Form forms = 1;
   */
  forms: Form[];
};

/**
 * Describes the message api_proto.v1.GetDealFormsResponse.
 * Use `create(GetDealFormsResponseSchema)` to create a new message.
 */
export const GetDealFormsResponseSchema: GenMessage<GetDealFormsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 4);

/**
 * 詳細作成
 *
 * @generated from message api_proto.v1.CreateDealRequest
 */
export type CreateDealRequest = Message<"api_proto.v1.CreateDealRequest"> & {
  /**
   * @generated from field: repeated api_proto.v1.FormRequest values = 1;
   */
  values: FormRequest[];
};

/**
 * Describes the message api_proto.v1.CreateDealRequest.
 * Use `create(CreateDealRequestSchema)` to create a new message.
 */
export const CreateDealRequestSchema: GenMessage<CreateDealRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 5);

/**
 * @generated from message api_proto.v1.CreateDealResponse
 */
export type CreateDealResponse = Message<"api_proto.v1.CreateDealResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: repeated api_proto.v1.FormValue values = 2;
   */
  values: FormValue[];
};

/**
 * Describes the message api_proto.v1.CreateDealResponse.
 * Use `create(CreateDealResponseSchema)` to create a new message.
 */
export const CreateDealResponseSchema: GenMessage<CreateDealResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 6);

/**
 * 案件必須系機能（現地調査報告書・施工事例記事）の中からの案件作成（決定 63）。
 * 案件の作成可否は crm.deals ではなく呼び出し元機能の権限（full）で判定するため、
 * どの機能から呼ばれたかを feature_permission_code で受け取る。
 *
 * @generated from message api_proto.v1.CreateDealForFeatureRequest
 */
export type CreateDealForFeatureRequest = Message<"api_proto.v1.CreateDealForFeatureRequest"> & {
  /**
   * ai.survey_report / free.case_study のみ許可。他は InvalidArgument
   *
   * @generated from field: string feature_permission_code = 1;
   */
  featurePermissionCode: string;

  /**
   * @generated from oneof api_proto.v1.CreateDealForFeatureRequest.customer
   */
  customer: {
    /**
     * 既存顧客を選ぶ場合
     *
     * @generated from field: int64 customer_id = 2;
     */
    value: bigint;
    case: "customerId";
  } | {
    /**
     * 新規顧客を作る場合の顧客名（1〜100 文字）
     *
     * @generated from field: string new_customer_name = 3;
     */
    value: string;
    case: "newCustomerName";
  } | { case: undefined; value?: undefined };

  /**
   * 空なら「{顧客名}様邸工事」
   *
   * @generated from field: string deal_name = 4;
   */
  dealName: string;

  /**
   * 作った案件をこの AIカラープロジェクト（ULID）に同じトランザクションで連携する。空なら案件だけ作る。
   * 指定時は ai.color_simulation の実効権限 full も要求し、プロジェクトは自社・未連携であること。
   * プロジェクトに顧客が設定済みなら customer_id はその顧客であること（新規顧客名は不可）。
   *
   * @generated from field: string ai_color_project_id = 5;
   */
  aiColorProjectId: string;
};

/**
 * Describes the message api_proto.v1.CreateDealForFeatureRequest.
 * Use `create(CreateDealForFeatureRequestSchema)` to create a new message.
 */
export const CreateDealForFeatureRequestSchema: GenMessage<CreateDealForFeatureRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 7);

/**
 * @generated from message api_proto.v1.CreateDealForFeatureResponse
 */
export type CreateDealForFeatureResponse = Message<"api_proto.v1.CreateDealForFeatureResponse"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: int64 customer_id = 2;
   */
  customerId: bigint;
};

/**
 * Describes the message api_proto.v1.CreateDealForFeatureResponse.
 * Use `create(CreateDealForFeatureResponseSchema)` to create a new message.
 */
export const CreateDealForFeatureResponseSchema: GenMessage<CreateDealForFeatureResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 8);

/**
 * 案件必須系機能（現地調査報告書・施工事例記事）の画面から、案件名と、案件に紐づく顧客の名前を直す。
 * 営業支援プランだけの企業は crm.deals / crm.customers が readonly なので UpdateDealPartial / UpdateCustomer
 * を呼べないが、報告書の画面で案件名・顧客名を編集する欄は以前からあり、報告書のPDFにも載る。
 * CreateDealForFeature（機能の中から案件を作る。決定63）と同じく、資格は feature_permission_code が指す
 * 機能の実効権限（full）で判定し、宣言（rpcpermission）は crm.deals: readonly に留める。
 * 対象は deal_id の案件と「その案件に紐づく顧客」に限り、顧客IDは受け取らない（任意のIDを受けて
 * 実在を推測される経路にしないため）。他社・不在の案件は NotFound。
 *
 * @generated from message api_proto.v1.UpdateDealForFeatureRequest
 */
export type UpdateDealForFeatureRequest = Message<"api_proto.v1.UpdateDealForFeatureRequest"> & {
  /**
   * ai.survey_report / free.case_study のみ許可。他は InvalidArgument
   *
   * @generated from field: string feature_permission_code = 1;
   */
  featurePermissionCode: string;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * 未指定 = 現状維持（指定した項目だけを更新する。更新系RPCの既定「全項目置換」の例外）。
   * 案件名は案件フォームの「name」項目と同じ検証（UpdateDealPartial と同じ経路）を通る。
   *
   * @generated from field: optional string deal_name = 3;
   */
  dealName?: string;

  /**
   * 未指定 = 現状維持。顧客の他の項目（電話・住所など）には触れない。
   * 長さの規則は CreateDealForFeature の new_customer_name と同じ（1〜100文字、前後の空白は除く。
   * 定義は go/company_usecase の featureDealCustomerName{Min,Max}Length）。顧客画面の UpdateCustomer
   * （必須のみ・上限なし）とは別の規則で、SSOT はこちらの定数。案件に顧客が紐づいていなければ InvalidArgument。
   *
   * @generated from field: optional string customer_name = 4;
   */
  customerName?: string;
};

/**
 * Describes the message api_proto.v1.UpdateDealForFeatureRequest.
 * Use `create(UpdateDealForFeatureRequestSchema)` to create a new message.
 */
export const UpdateDealForFeatureRequestSchema: GenMessage<UpdateDealForFeatureRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 9);

/**
 * @generated from message api_proto.v1.UpdateDealForFeatureResponse
 */
export type UpdateDealForFeatureResponse = Message<"api_proto.v1.UpdateDealForFeatureResponse"> & {
};

/**
 * Describes the message api_proto.v1.UpdateDealForFeatureResponse.
 * Use `create(UpdateDealForFeatureResponseSchema)` to create a new message.
 */
export const UpdateDealForFeatureResponseSchema: GenMessage<UpdateDealForFeatureResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 10);

/**
 * @generated from message api_proto.v1.UpdateDealRequest
 */
export type UpdateDealRequest = Message<"api_proto.v1.UpdateDealRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: repeated api_proto.v1.FormRequest values = 2;
   */
  values: FormRequest[];
};

/**
 * Describes the message api_proto.v1.UpdateDealRequest.
 * Use `create(UpdateDealRequestSchema)` to create a new message.
 */
export const UpdateDealRequestSchema: GenMessage<UpdateDealRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 11);

/**
 * @generated from message api_proto.v1.UpdateDealResponse
 */
export type UpdateDealResponse = Message<"api_proto.v1.UpdateDealResponse"> & {
};

/**
 * Describes the message api_proto.v1.UpdateDealResponse.
 * Use `create(UpdateDealResponseSchema)` to create a new message.
 */
export const UpdateDealResponseSchema: GenMessage<UpdateDealResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 12);

/**
 * status更新
 *
 * @generated from message api_proto.v1.UpdateDealStatusRequest
 */
export type UpdateDealStatusRequest = Message<"api_proto.v1.UpdateDealStatusRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: api_proto.v1.DealStatus status = 2;
   */
  status: DealStatus;
};

/**
 * Describes the message api_proto.v1.UpdateDealStatusRequest.
 * Use `create(UpdateDealStatusRequestSchema)` to create a new message.
 */
export const UpdateDealStatusRequestSchema: GenMessage<UpdateDealStatusRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 13);

/**
 * @generated from message api_proto.v1.UpdateDealStatusResponse
 */
export type UpdateDealStatusResponse = Message<"api_proto.v1.UpdateDealStatusResponse"> & {
};

/**
 * Describes the message api_proto.v1.UpdateDealStatusResponse.
 * Use `create(UpdateDealStatusResponseSchema)` to create a new message.
 */
export const UpdateDealStatusResponseSchema: GenMessage<UpdateDealStatusResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 14);

/**
 * @generated from message api_proto.v1.DealSortRequest
 */
export type DealSortRequest = Message<"api_proto.v1.DealSortRequest"> & {
  /**
   * deal_form_valuesで扱えないものはenumで定義
   *
   * @generated from field: api_proto.v1.DealSortKey string = 1;
   */
  string: DealSortKey;

  /**
   * @generated from field: api_proto.v1.Order sort_order = 2;
   */
  sortOrder: Order;
};

/**
 * Describes the message api_proto.v1.DealSortRequest.
 * Use `create(DealSortRequestSchema)` to create a new message.
 */
export const DealSortRequestSchema: GenMessage<DealSortRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 15);

/**
 * @generated from message api_proto.v1.DealSearchFreeWordRequest
 */
export type DealSearchFreeWordRequest = Message<"api_proto.v1.DealSearchFreeWordRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message api_proto.v1.DealSearchFreeWordRequest.
 * Use `create(DealSearchFreeWordRequestSchema)` to create a new message.
 */
export const DealSearchFreeWordRequestSchema: GenMessage<DealSearchFreeWordRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 16);

/**
 * @generated from message api_proto.v1.DealSearchDateRequest
 */
export type DealSearchDateRequest = Message<"api_proto.v1.DealSearchDateRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 両方が空の場合はnull(未入力)を検索
   *
   * @generated from field: optional google.protobuf.Timestamp start_date = 2;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp;
};

/**
 * Describes the message api_proto.v1.DealSearchDateRequest.
 * Use `create(DealSearchDateRequestSchema)` to create a new message.
 */
export const DealSearchDateRequestSchema: GenMessage<DealSearchDateRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 17);

/**
 * @generated from message api_proto.v1.DealSearchIntRequest
 */
export type DealSearchIntRequest = Message<"api_proto.v1.DealSearchIntRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 両方が空の場合はnull(未入力)を検索
   *
   * @generated from field: optional int64 min = 2;
   */
  min?: bigint;

  /**
   * @generated from field: optional int64 max = 3;
   */
  max?: bigint;
};

/**
 * Describes the message api_proto.v1.DealSearchIntRequest.
 * Use `create(DealSearchIntRequestSchema)` to create a new message.
 */
export const DealSearchIntRequestSchema: GenMessage<DealSearchIntRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 18);

/**
 * @generated from message api_proto.v1.DealSearchTextValueRequest
 */
export type DealSearchTextValueRequest = Message<"api_proto.v1.DealSearchTextValueRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * フォームのタイプを指定することで、検索対象のフォームを絞ることができる
   *
   * @generated from field: api_proto.v1.FormType form_type = 3;
   */
  formType: FormType;
};

/**
 * Describes the message api_proto.v1.DealSearchTextValueRequest.
 * Use `create(DealSearchTextValueRequestSchema)` to create a new message.
 */
export const DealSearchTextValueRequestSchema: GenMessage<DealSearchTextValueRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 19);

/**
 * @generated from message api_proto.v1.DealSearchDetailRequest
 */
export type DealSearchDetailRequest = Message<"api_proto.v1.DealSearchDetailRequest"> & {
  /**
   * 検索に使用するtext/min/max/start_date/end_dateは名前の重複NG
   *
   * @generated from oneof api_proto.v1.DealSearchDetailRequest.search
   */
  search: {
    /**
     * @generated from field: api_proto.v1.DealSearchFreeWordRequest free_word = 1;
     */
    value: DealSearchFreeWordRequest;
    case: "freeWord";
  } | {
    /**
     * @generated from field: api_proto.v1.DealSearchDateRequest date = 2;
     */
    value: DealSearchDateRequest;
    case: "date";
  } | {
    /**
     * @generated from field: api_proto.v1.DealSearchIntRequest int = 3;
     */
    value: DealSearchIntRequest;
    case: "int";
  } | {
    /**
     * @generated from field: api_proto.v1.DealSearchTextValueRequest value = 4;
     */
    value: DealSearchTextValueRequest;
    case: "value";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message api_proto.v1.DealSearchDetailRequest.
 * Use `create(DealSearchDetailRequestSchema)` to create a new message.
 */
export const DealSearchDetailRequestSchema: GenMessage<DealSearchDetailRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 20);

/**
 * @generated from message api_proto.v1.GetDealListRequest
 */
export type GetDealListRequest = Message<"api_proto.v1.GetDealListRequest"> & {
  /**
   * @generated from field: int64 page = 1;
   */
  page: bigint;

  /**
   * @generated from field: int64 page_size = 2;
   */
  pageSize: bigint;

  /**
   * DealSortRequestの配列
   *
   * @generated from field: google.protobuf.ListValue sort_infos = 3;
   */
  sortInfos?: ListValue;

  /**
   * @generated from field: string free_word = 4;
   */
  freeWord: string;

  /**
   * company_staff_idsを使用すること
   *
   * @generated from field: optional int64 company_staff_id = 5 [deprecated = true];
   * @deprecated
   */
  companyStaffId?: bigint;

  /**
   * @generated from field: optional string customer_name = 6;
   */
  customerName?: string;

  /**
   * @generated from field: repeated api_proto.v1.DealStatus statuses = 7;
   */
  statuses: DealStatus[];

  /**
   * DealSearchDetailRequestの配列
   *
   * @generated from field: google.protobuf.ListValue search_detail = 8;
   */
  searchDetail?: ListValue;

  /**
   * statusesを使用すること
   *
   * @generated from field: optional api_proto.v1.DealStatus status = 9 [deprecated = true];
   * @deprecated
   */
  status?: DealStatus;

  /**
   * @generated from field: optional string address = 10;
   */
  address?: string;

  /**
   * @generated from field: optional int64 customer_id = 11;
   */
  customerId?: bigint;

  /**
   * @generated from field: repeated int64 company_staff_ids = 12;
   */
  companyStaffIds: bigint[];
};

/**
 * Describes the message api_proto.v1.GetDealListRequest.
 * Use `create(GetDealListRequestSchema)` to create a new message.
 */
export const GetDealListRequestSchema: GenMessage<GetDealListRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 21);

/**
 * @generated from message api_proto.v1.GetDealResponse
 */
export type GetDealResponse = Message<"api_proto.v1.GetDealResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string staff_name = 3;
   */
  staffName: string;

  /**
   * @generated from field: string customer_name = 4;
   */
  customerName: string;

  /**
   * @generated from field: string customer_name_full = 5;
   */
  customerNameFull: string;

  /**
   * @generated from field: string external_system_id = 6;
   */
  externalSystemId: string;

  /**
   * @generated from field: api_proto.v1.DealStatus status = 7;
   */
  status: DealStatus;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 8;
   */
  updated?: Timestamp;

  /**
   * @generated from field: repeated api_proto.v1.FormValue values = 9;
   */
  values: FormValue[];

  /**
   * @generated from field: repeated api_proto.v1.DealMemoResponse memos = 10;
   */
  memos: DealMemoResponse[];

  /**
   * @generated from field: google.protobuf.Timestamp created = 11;
   */
  created?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp registration_date = 12;
   */
  registrationDate?: Timestamp;

  /**
   * 案件一覧で表示する最新のメモ
   *
   * @generated from field: optional api_proto.v1.DealMemoResponse latest_memo = 13;
   */
  latestMemo?: DealMemoResponse;

  /**
   * 現地調査報告書（未削除）がこの案件にあるか。GetDealList でのみ設定する。
   * 報告書の作成ページの案件選択で「作成済み」を出すのに使う（1 案件 1 報告書。決定 72）。
   *
   * @generated from field: bool has_survey_report = 14;
   */
  hasSurveyReport: boolean;

  /**
   * フリーワード（free_word）の語を含むメモ。GetDealList でフリーワード指定時のみ設定し、
   * 語を含むメモが無い案件では未設定。一覧のメモ欄は、これがあるとき latest_memo の代わりに出す。
   *
   * @generated from field: optional api_proto.v1.DealListMatchedMemo matched_memo = 15;
   */
  matchedMemo?: DealListMatchedMemo;
};

/**
 * Describes the message api_proto.v1.GetDealResponse.
 * Use `create(GetDealResponseSchema)` to create a new message.
 */
export const GetDealResponseSchema: GenMessage<GetDealResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 22);

/**
 * 案件一覧のフリーワード検索で語を含んだメモ（案件ごとに1件）。
 * 案件対応メモと、案件の顧客の顧客対応メモから、含む語の数が多いものを選ぶ（同数なら案件対応メモ）。
 *
 * @generated from message api_proto.v1.DealListMatchedMemo
 */
export type DealListMatchedMemo = Message<"api_proto.v1.DealListMatchedMemo"> & {
  /**
   * @generated from field: api_proto.v1.DealListMatchedMemoSource source = 1;
   */
  source: DealListMatchedMemoSource;

  /**
   * @generated from field: int64 memo_id = 2;
   */
  memoId: bigint;

  /**
   * 最初に当たった語の少し手前から切り出した抜粋。改行は空白にし、切った側に「…」を付ける
   *
   * @generated from field: string excerpt = 3;
   */
  excerpt: string;

  /**
   * 全文（ホバーで見せる）
   *
   * @generated from field: string memo = 4;
   */
  memo: string;

  /**
   * @generated from field: google.protobuf.Timestamp registration_date = 5;
   */
  registrationDate?: Timestamp;
};

/**
 * Describes the message api_proto.v1.DealListMatchedMemo.
 * Use `create(DealListMatchedMemoSchema)` to create a new message.
 */
export const DealListMatchedMemoSchema: GenMessage<DealListMatchedMemo> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 23);

/**
 * @generated from message api_proto.v1.GetDealListResponse
 */
export type GetDealListResponse = Message<"api_proto.v1.GetDealListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.GetDealResponse deals = 1;
   */
  deals: GetDealResponse[];

  /**
   * @generated from field: int64 total_page = 2;
   */
  totalPage: bigint;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;

  /**
   * @generated from field: double total_quotation_amount = 4;
   */
  totalQuotationAmount: number;

  /**
   * @generated from field: double total_contract_amount = 5;
   */
  totalContractAmount: number;

  /**
   * @generated from field: double total_complete_amount = 6;
   */
  totalCompleteAmount: number;
};

/**
 * Describes the message api_proto.v1.GetDealListResponse.
 * Use `create(GetDealListResponseSchema)` to create a new message.
 */
export const GetDealListResponseSchema: GenMessage<GetDealListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 24);

/**
 * CSV Export
 *
 * @generated from message api_proto.v1.GetDealListCSVResponse
 */
export type GetDealListCSVResponse = Message<"api_proto.v1.GetDealListCSVResponse"> & {
  /**
   * @generated from field: bytes csv_data = 1;
   */
  csvData: Uint8Array;

  /**
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;

  /**
   * @generated from field: double total_quotation_amount = 3;
   */
  totalQuotationAmount: number;

  /**
   * @generated from field: double total_contract_amount = 4;
   */
  totalContractAmount: number;

  /**
   * @generated from field: double total_complete_amount = 5;
   */
  totalCompleteAmount: number;

  /**
   * Shift-JIS変換でエラーが発生したかのフラグ
   *
   * @generated from field: bool has_conversion_error = 6;
   */
  hasConversionError: boolean;
};

/**
 * Describes the message api_proto.v1.GetDealListCSVResponse.
 * Use `create(GetDealListCSVResponseSchema)` to create a new message.
 */
export const GetDealListCSVResponseSchema: GenMessage<GetDealListCSVResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 25);

/**
 * 案件保存検索関連
 *
 * @generated from message api_proto.v1.DealSavedSearch
 */
export type DealSavedSearch = Message<"api_proto.v1.DealSavedSearch"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 company_id = 2;
   */
  companyId: bigint;

  /**
   * @generated from field: int64 company_staff_id = 3;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * 検索クエリー文字列（URLパラメータ形式）
   *
   * @generated from field: string search_query = 5;
   */
  searchQuery: string;

  /**
   * @generated from field: bool is_default = 6;
   */
  isDefault: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp registration_date = 7;
   */
  registrationDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp app_updated = 8;
   */
  appUpdated?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created = 9;
   */
  created?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 10;
   */
  updated?: Timestamp;

  /**
   * 自分が作成した検索条件かどうか
   *
   * @generated from field: bool is_mine = 11;
   */
  isMine: boolean;
};

/**
 * Describes the message api_proto.v1.DealSavedSearch.
 * Use `create(DealSavedSearchSchema)` to create a new message.
 */
export const DealSavedSearchSchema: GenMessage<DealSavedSearch> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 26);

/**
 * @generated from message api_proto.v1.CreateDealSavedSearchRequest
 */
export type CreateDealSavedSearchRequest = Message<"api_proto.v1.CreateDealSavedSearchRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 検索クエリー文字列（URLパラメータ形式）
   *
   * @generated from field: string search_query = 2;
   */
  searchQuery: string;

  /**
   * @generated from field: bool is_default = 3;
   */
  isDefault: boolean;
};

/**
 * Describes the message api_proto.v1.CreateDealSavedSearchRequest.
 * Use `create(CreateDealSavedSearchRequestSchema)` to create a new message.
 */
export const CreateDealSavedSearchRequestSchema: GenMessage<CreateDealSavedSearchRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 27);

/**
 * @generated from message api_proto.v1.CreateDealSavedSearchResponse
 */
export type CreateDealSavedSearchResponse = Message<"api_proto.v1.CreateDealSavedSearchResponse"> & {
  /**
   * @generated from field: api_proto.v1.DealSavedSearch saved_search = 1;
   */
  savedSearch?: DealSavedSearch;
};

/**
 * Describes the message api_proto.v1.CreateDealSavedSearchResponse.
 * Use `create(CreateDealSavedSearchResponseSchema)` to create a new message.
 */
export const CreateDealSavedSearchResponseSchema: GenMessage<CreateDealSavedSearchResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 28);

/**
 * @generated from message api_proto.v1.GetDealSavedSearchListRequest
 */
export type GetDealSavedSearchListRequest = Message<"api_proto.v1.GetDealSavedSearchListRequest"> & {
  /**
   * @generated from field: int64 page = 1;
   */
  page: bigint;

  /**
   * @generated from field: int64 page_size = 2;
   */
  pageSize: bigint;
};

/**
 * Describes the message api_proto.v1.GetDealSavedSearchListRequest.
 * Use `create(GetDealSavedSearchListRequestSchema)` to create a new message.
 */
export const GetDealSavedSearchListRequestSchema: GenMessage<GetDealSavedSearchListRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 29);

/**
 * @generated from message api_proto.v1.GetDealSavedSearchListResponse
 */
export type GetDealSavedSearchListResponse = Message<"api_proto.v1.GetDealSavedSearchListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.DealSavedSearch saved_searches = 1;
   */
  savedSearches: DealSavedSearch[];

  /**
   * @generated from field: int64 total_page = 2;
   */
  totalPage: bigint;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;
};

/**
 * Describes the message api_proto.v1.GetDealSavedSearchListResponse.
 * Use `create(GetDealSavedSearchListResponseSchema)` to create a new message.
 */
export const GetDealSavedSearchListResponseSchema: GenMessage<GetDealSavedSearchListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 30);

/**
 * @generated from message api_proto.v1.GetDealSavedSearchRequest
 */
export type GetDealSavedSearchRequest = Message<"api_proto.v1.GetDealSavedSearchRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.GetDealSavedSearchRequest.
 * Use `create(GetDealSavedSearchRequestSchema)` to create a new message.
 */
export const GetDealSavedSearchRequestSchema: GenMessage<GetDealSavedSearchRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 31);

/**
 * @generated from message api_proto.v1.GetDealSavedSearchResponse
 */
export type GetDealSavedSearchResponse = Message<"api_proto.v1.GetDealSavedSearchResponse"> & {
  /**
   * @generated from field: api_proto.v1.DealSavedSearch saved_search = 1;
   */
  savedSearch?: DealSavedSearch;
};

/**
 * Describes the message api_proto.v1.GetDealSavedSearchResponse.
 * Use `create(GetDealSavedSearchResponseSchema)` to create a new message.
 */
export const GetDealSavedSearchResponseSchema: GenMessage<GetDealSavedSearchResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 32);

/**
 * @generated from message api_proto.v1.UpdateDealSavedSearchRequest
 */
export type UpdateDealSavedSearchRequest = Message<"api_proto.v1.UpdateDealSavedSearchRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 検索クエリー文字列（URLパラメータ形式）
   *
   * @generated from field: string search_query = 3;
   */
  searchQuery: string;

  /**
   * @generated from field: bool is_default = 4;
   */
  isDefault: boolean;
};

/**
 * Describes the message api_proto.v1.UpdateDealSavedSearchRequest.
 * Use `create(UpdateDealSavedSearchRequestSchema)` to create a new message.
 */
export const UpdateDealSavedSearchRequestSchema: GenMessage<UpdateDealSavedSearchRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 33);

/**
 * @generated from message api_proto.v1.UpdateDealSavedSearchResponse
 */
export type UpdateDealSavedSearchResponse = Message<"api_proto.v1.UpdateDealSavedSearchResponse"> & {
  /**
   * @generated from field: api_proto.v1.DealSavedSearch saved_search = 1;
   */
  savedSearch?: DealSavedSearch;
};

/**
 * Describes the message api_proto.v1.UpdateDealSavedSearchResponse.
 * Use `create(UpdateDealSavedSearchResponseSchema)` to create a new message.
 */
export const UpdateDealSavedSearchResponseSchema: GenMessage<UpdateDealSavedSearchResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 34);

/**
 * @generated from message api_proto.v1.DeleteDealSavedSearchRequest
 */
export type DeleteDealSavedSearchRequest = Message<"api_proto.v1.DeleteDealSavedSearchRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteDealSavedSearchRequest.
 * Use `create(DeleteDealSavedSearchRequestSchema)` to create a new message.
 */
export const DeleteDealSavedSearchRequestSchema: GenMessage<DeleteDealSavedSearchRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 35);

/**
 * @generated from message api_proto.v1.DeleteDealSavedSearchResponse
 */
export type DeleteDealSavedSearchResponse = Message<"api_proto.v1.DeleteDealSavedSearchResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteDealSavedSearchResponse.
 * Use `create(DeleteDealSavedSearchResponseSchema)` to create a new message.
 */
export const DeleteDealSavedSearchResponseSchema: GenMessage<DeleteDealSavedSearchResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 36);

/**
 * 詳細
 *
 * @generated from message api_proto.v1.GetDealDetailRequest
 */
export type GetDealDetailRequest = Message<"api_proto.v1.GetDealDetailRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.GetDealDetailRequest.
 * Use `create(GetDealDetailRequestSchema)` to create a new message.
 */
export const GetDealDetailRequestSchema: GenMessage<GetDealDetailRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 37);

/**
 * 案件用の見積り
 *
 * @generated from message api_proto.v1.DealQuotation
 */
export type DealQuotation = Message<"api_proto.v1.DealQuotation"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.Timestamp quotation_at = 3;
   */
  quotationAt?: Timestamp;

  /**
   * @generated from field: double total_amount = 4;
   */
  totalAmount: number;

  /**
   * 見積書が連携している案件ID（他の案件に連携されている場合はその案件のIDが入る）
   *
   * @generated from field: optional int64 linked_deal_id = 5;
   */
  linkedDealId?: bigint;
};

/**
 * Describes the message api_proto.v1.DealQuotation.
 * Use `create(DealQuotationSchema)` to create a new message.
 */
export const DealQuotationSchema: GenMessage<DealQuotation> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 38);

/**
 * 案件用の請求書
 *
 * @generated from message api_proto.v1.DealInvoice
 */
export type DealInvoice = Message<"api_proto.v1.DealInvoice"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp invoice_at = 3;
   */
  invoiceAt?: Timestamp;

  /**
   * @generated from field: double total_amount = 4;
   */
  totalAmount: number;

  /**
   * 請求書が連携している案件ID（他の案件に連携されている場合はその案件のIDが入る）
   *
   * @generated from field: optional int64 linked_deal_id = 5;
   */
  linkedDealId?: bigint;
};

/**
 * Describes the message api_proto.v1.DealInvoice.
 * Use `create(DealInvoiceSchema)` to create a new message.
 */
export const DealInvoiceSchema: GenMessage<DealInvoice> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 39);

/**
 * 案件に紐づく現地調査報告書・施工事例記事の有無（書類連携モーダル・件数表示用）
 * 本文等の重いデータは含めない。プレビュー内容は既存 RPC（GetSurveyReport / GetCaseStudyArticlesByDealId）で取得する
 *
 * @generated from message api_proto.v1.DealDocumentPresence
 */
export type DealDocumentPresence = Message<"api_proto.v1.DealDocumentPresence"> & {
  /**
   * @generated from field: bool has_survey_report = 1;
   */
  hasSurveyReport: boolean;

  /**
   * 一覧表示用
   *
   * @generated from field: optional google.protobuf.Timestamp survey_report_updated_at = 2;
   */
  surveyReportUpdatedAt?: Timestamp;

  /**
   * @generated from field: bool has_case_study_article = 3;
   */
  hasCaseStudyArticle: boolean;

  /**
   * 一覧表示用
   *
   * @generated from field: optional google.protobuf.Timestamp case_study_article_created = 4;
   */
  caseStudyArticleCreated?: Timestamp;
};

/**
 * Describes the message api_proto.v1.DealDocumentPresence.
 * Use `create(DealDocumentPresenceSchema)` to create a new message.
 */
export const DealDocumentPresenceSchema: GenMessage<DealDocumentPresence> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 40);

/**
 * @generated from message api_proto.v1.GetDealDetailResponse
 */
export type GetDealDetailResponse = Message<"api_proto.v1.GetDealDetailResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 staff_id = 2;
   */
  staffId: bigint;

  /**
   * @generated from field: string staff_name = 3;
   */
  staffName: string;

  /**
   * @generated from field: string customer_name = 4;
   */
  customerName: string;

  /**
   * @generated from field: string customer_name_full = 5;
   */
  customerNameFull: string;

  /**
   * @generated from field: string external_system_id = 6;
   */
  externalSystemId: string;

  /**
   * @generated from field: int64 customer_id = 7;
   */
  customerId: bigint;

  /**
   * @generated from field: api_proto.v1.DealStatus status = 8;
   */
  status: DealStatus;

  /**
   * @generated from field: google.protobuf.Timestamp registration_date = 9;
   */
  registrationDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp app_updated = 10;
   */
  appUpdated?: Timestamp;

  /**
   * @generated from field: repeated api_proto.v1.FormValue values = 11;
   */
  values: FormValue[];

  /**
   * @generated from field: repeated api_proto.v1.DealQuotation quotations = 12;
   */
  quotations: DealQuotation[];

  /**
   * @generated from field: repeated api_proto.v1.DealInvoice invoices = 13;
   */
  invoices: DealInvoice[];

  /**
   * @generated from field: repeated api_proto.v1.AdditionalContract additional_contracts = 14;
   */
  additionalContracts: AdditionalContract[];

  /**
   * @generated from field: api_proto.v1.DealDocumentPresence document_presence = 15;
   */
  documentPresence?: DealDocumentPresence;

  /**
   * いえサプリ外で作成された見積書・請求書 PDF (issue #2404)。
   * 見積書一覧・請求書一覧には出さないため quotations / invoices とは混ぜない
   *
   * @generated from field: repeated api_proto.v1.DealExternalDocument external_documents = 16;
   */
  externalDocuments: DealExternalDocument[];
};

/**
 * Describes the message api_proto.v1.GetDealDetailResponse.
 * Use `create(GetDealDetailResponseSchema)` to create a new message.
 */
export const GetDealDetailResponseSchema: GenMessage<GetDealDetailResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 41);

/**
 * 削除
 *
 * @generated from message api_proto.v1.DeleteDealRequest
 */
export type DeleteDealRequest = Message<"api_proto.v1.DeleteDealRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteDealRequest.
 * Use `create(DeleteDealRequestSchema)` to create a new message.
 */
export const DeleteDealRequestSchema: GenMessage<DeleteDealRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 42);

/**
 * @generated from message api_proto.v1.DeleteMultipleDealRequest
 */
export type DeleteMultipleDealRequest = Message<"api_proto.v1.DeleteMultipleDealRequest"> & {
  /**
   * @generated from field: repeated int64 ids = 1;
   */
  ids: bigint[];
};

/**
 * Describes the message api_proto.v1.DeleteMultipleDealRequest.
 * Use `create(DeleteMultipleDealRequestSchema)` to create a new message.
 */
export const DeleteMultipleDealRequestSchema: GenMessage<DeleteMultipleDealRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 43);

/**
 * 部分更新
 *
 * @generated from message api_proto.v1.UpdateDealPartialRequest
 */
export type UpdateDealPartialRequest = Message<"api_proto.v1.UpdateDealPartialRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: api_proto.v1.FormRequest value = 2;
   */
  value?: FormRequest;
};

/**
 * Describes the message api_proto.v1.UpdateDealPartialRequest.
 * Use `create(UpdateDealPartialRequestSchema)` to create a new message.
 */
export const UpdateDealPartialRequestSchema: GenMessage<UpdateDealPartialRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 44);

/**
 * @generated from message api_proto.v1.UpdateAllDealCustomerTypeRequest
 */
export type UpdateAllDealCustomerTypeRequest = Message<"api_proto.v1.UpdateAllDealCustomerTypeRequest"> & {
  /**
   * @generated from field: int64 customer_id = 1;
   */
  customerId: bigint;

  /**
   * @generated from field: api_proto.v1.CustomerType customer_type = 2;
   */
  customerType: CustomerType;
};

/**
 * Describes the message api_proto.v1.UpdateAllDealCustomerTypeRequest.
 * Use `create(UpdateAllDealCustomerTypeRequestSchema)` to create a new message.
 */
export const UpdateAllDealCustomerTypeRequestSchema: GenMessage<UpdateAllDealCustomerTypeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 45);

/**
 * 工事内容選択肢取得
 *
 * @generated from message api_proto.v1.GetConstructionContentOptionsRequest
 */
export type GetConstructionContentOptionsRequest = Message<"api_proto.v1.GetConstructionContentOptionsRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetConstructionContentOptionsRequest.
 * Use `create(GetConstructionContentOptionsRequestSchema)` to create a new message.
 */
export const GetConstructionContentOptionsRequestSchema: GenMessage<GetConstructionContentOptionsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 46);

/**
 * @generated from message api_proto.v1.ConstructionContentOption
 */
export type ConstructionContentOption = Message<"api_proto.v1.ConstructionContentOption"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: int32 sort_order = 3;
   */
  sortOrder: number;
};

/**
 * Describes the message api_proto.v1.ConstructionContentOption.
 * Use `create(ConstructionContentOptionSchema)` to create a new message.
 */
export const ConstructionContentOptionSchema: GenMessage<ConstructionContentOption> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 47);

/**
 * @generated from message api_proto.v1.GetConstructionContentOptionsResponse
 */
export type GetConstructionContentOptionsResponse = Message<"api_proto.v1.GetConstructionContentOptionsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.ConstructionContentOption options = 1;
   */
  options: ConstructionContentOption[];
};

/**
 * Describes the message api_proto.v1.GetConstructionContentOptionsResponse.
 * Use `create(GetConstructionContentOptionsResponseSchema)` to create a new message.
 */
export const GetConstructionContentOptionsResponseSchema: GenMessage<GetConstructionContentOptionsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 48);

/**
 * 案件から見積書を作成する
 *
 * @generated from message api_proto.v1.CreateQuotationFromDealRequest
 */
export type CreateQuotationFromDealRequest = Message<"api_proto.v1.CreateQuotationFromDealRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * 案件から取得した顧客ID
   *
   * @generated from field: int64 customer_id = 2;
   */
  customerId: bigint;

  /**
   * 最低限の必須項目のみ
   *
   * 見積日
   *
   * @generated from field: google.protobuf.Timestamp quotation_at = 3;
   */
  quotationAt?: Timestamp;

  /**
   * フォーマットタイプ（通常は"single"）
   *
   * @generated from field: string format_type = 4;
   */
  formatType: string;
};

/**
 * Describes the message api_proto.v1.CreateQuotationFromDealRequest.
 * Use `create(CreateQuotationFromDealRequestSchema)` to create a new message.
 */
export const CreateQuotationFromDealRequestSchema: GenMessage<CreateQuotationFromDealRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 49);

/**
 * @generated from message api_proto.v1.CreateQuotationFromDealResponse
 */
export type CreateQuotationFromDealResponse = Message<"api_proto.v1.CreateQuotationFromDealResponse"> & {
  /**
   * @generated from field: int64 quotation_id = 1;
   */
  quotationId: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * 見積書番号が重複していた場合true
   *
   * @generated from field: bool number_duplicate = 3;
   */
  numberDuplicate: boolean;
};

/**
 * Describes the message api_proto.v1.CreateQuotationFromDealResponse.
 * Use `create(CreateQuotationFromDealResponseSchema)` to create a new message.
 */
export const CreateQuotationFromDealResponseSchema: GenMessage<CreateQuotationFromDealResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 50);

/**
 * 案件に既存の見積書を紐付ける
 *
 * @generated from message api_proto.v1.LinkQuotationToDealRequest
 */
export type LinkQuotationToDealRequest = Message<"api_proto.v1.LinkQuotationToDealRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: int64 quotation_id = 2;
   */
  quotationId: bigint;

  /**
   * 案件の情報で書類を更新したいかどうか
   *
   * @generated from field: bool want_update = 3;
   */
  wantUpdate: boolean;
};

/**
 * Describes the message api_proto.v1.LinkQuotationToDealRequest.
 * Use `create(LinkQuotationToDealRequestSchema)` to create a new message.
 */
export const LinkQuotationToDealRequestSchema: GenMessage<LinkQuotationToDealRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 51);

/**
 * @generated from message api_proto.v1.LinkQuotationToDealResponse
 */
export type LinkQuotationToDealResponse = Message<"api_proto.v1.LinkQuotationToDealResponse"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: int64 quotation_id = 2;
   */
  quotationId: bigint;
};

/**
 * Describes the message api_proto.v1.LinkQuotationToDealResponse.
 * Use `create(LinkQuotationToDealResponseSchema)` to create a new message.
 */
export const LinkQuotationToDealResponseSchema: GenMessage<LinkQuotationToDealResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 52);

/**
 * 案件から請求書を作成する
 *
 * @generated from message api_proto.v1.CreateInvoiceFromDealRequest
 */
export type CreateInvoiceFromDealRequest = Message<"api_proto.v1.CreateInvoiceFromDealRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * 案件から取得した顧客ID
   *
   * @generated from field: int64 customer_id = 2;
   */
  customerId: bigint;

  /**
   * 最低限の必須項目のみ
   *
   * 請求日
   *
   * @generated from field: google.protobuf.Timestamp invoice_at = 3;
   */
  invoiceAt?: Timestamp;

  /**
   * フォーマットタイプ（通常は"single"）
   *
   * @generated from field: string format_type = 4;
   */
  formatType: string;
};

/**
 * Describes the message api_proto.v1.CreateInvoiceFromDealRequest.
 * Use `create(CreateInvoiceFromDealRequestSchema)` to create a new message.
 */
export const CreateInvoiceFromDealRequestSchema: GenMessage<CreateInvoiceFromDealRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 53);

/**
 * @generated from message api_proto.v1.CreateInvoiceFromDealResponse
 */
export type CreateInvoiceFromDealResponse = Message<"api_proto.v1.CreateInvoiceFromDealResponse"> & {
  /**
   * @generated from field: int64 invoice_id = 1;
   */
  invoiceId: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * 請求書番号が重複していた場合true
   *
   * @generated from field: bool number_duplicate = 3;
   */
  numberDuplicate: boolean;
};

/**
 * Describes the message api_proto.v1.CreateInvoiceFromDealResponse.
 * Use `create(CreateInvoiceFromDealResponseSchema)` to create a new message.
 */
export const CreateInvoiceFromDealResponseSchema: GenMessage<CreateInvoiceFromDealResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 54);

/**
 * 案件に既存の請求書を紐付ける
 *
 * @generated from message api_proto.v1.LinkInvoiceToDealRequest
 */
export type LinkInvoiceToDealRequest = Message<"api_proto.v1.LinkInvoiceToDealRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: int64 invoice_id = 2;
   */
  invoiceId: bigint;

  /**
   * 案件の情報で書類を更新したいかどうか
   *
   * @generated from field: bool want_update = 3;
   */
  wantUpdate: boolean;
};

/**
 * Describes the message api_proto.v1.LinkInvoiceToDealRequest.
 * Use `create(LinkInvoiceToDealRequestSchema)` to create a new message.
 */
export const LinkInvoiceToDealRequestSchema: GenMessage<LinkInvoiceToDealRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 55);

/**
 * @generated from message api_proto.v1.LinkInvoiceToDealResponse
 */
export type LinkInvoiceToDealResponse = Message<"api_proto.v1.LinkInvoiceToDealResponse"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: int64 invoice_id = 2;
   */
  invoiceId: bigint;
};

/**
 * Describes the message api_proto.v1.LinkInvoiceToDealResponse.
 * Use `create(LinkInvoiceToDealResponseSchema)` to create a new message.
 */
export const LinkInvoiceToDealResponseSchema: GenMessage<LinkInvoiceToDealResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 56);

/**
 * 追加工事契約関連
 * 追加契約フォーム取得
 *
 * @generated from message api_proto.v1.GetAdditionalContractFormRequest
 */
export type GetAdditionalContractFormRequest = Message<"api_proto.v1.GetAdditionalContractFormRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetAdditionalContractFormRequest.
 * Use `create(GetAdditionalContractFormRequestSchema)` to create a new message.
 */
export const GetAdditionalContractFormRequestSchema: GenMessage<GetAdditionalContractFormRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 57);

/**
 * @generated from message api_proto.v1.GetAdditionalContractFormResponse
 */
export type GetAdditionalContractFormResponse = Message<"api_proto.v1.GetAdditionalContractFormResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.Form forms = 1;
   */
  forms: Form[];
};

/**
 * Describes the message api_proto.v1.GetAdditionalContractFormResponse.
 * Use `create(GetAdditionalContractFormResponseSchema)` to create a new message.
 */
export const GetAdditionalContractFormResponseSchema: GenMessage<GetAdditionalContractFormResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 58);

/**
 * 追加工事契約（レスポンス用）
 *
 * @generated from message api_proto.v1.AdditionalContract
 */
export type AdditionalContract = Message<"api_proto.v1.AdditionalContract"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: int64 company_staff_id = 4;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: string company_staff_name = 5;
   */
  companyStaffName: string;

  /**
   * @generated from field: google.protobuf.Timestamp contract_date = 6;
   */
  contractDate?: Timestamp;

  /**
   * @generated from field: repeated string construction_content = 7;
   */
  constructionContent: string[];

  /**
   * @generated from field: string construction_content_other = 8;
   */
  constructionContentOther: string;

  /**
   * @generated from field: string contract_memo = 9;
   */
  contractMemo: string;

  /**
   * @generated from field: string sales_amount = 10;
   */
  salesAmount: string;

  /**
   * @generated from field: string total_cost_amount = 11;
   */
  totalCostAmount: string;

  /**
   * @generated from field: string gross_profit = 12;
   */
  grossProfit: string;

  /**
   * @generated from field: string gross_profit_rate = 13;
   */
  grossProfitRate: string;

  /**
   * @generated from field: string advance_payment = 14;
   */
  advancePayment: string;

  /**
   * @generated from field: string balance_payment = 15;
   */
  balancePayment: string;

  /**
   * @generated from field: repeated api_proto.v1.CostElement cost_elements = 16;
   */
  costElements: CostElement[];

  /**
   * @generated from field: google.protobuf.Timestamp created = 17;
   */
  created?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 18;
   */
  updated?: Timestamp;
};

/**
 * Describes the message api_proto.v1.AdditionalContract.
 * Use `create(AdditionalContractSchema)` to create a new message.
 */
export const AdditionalContractSchema: GenMessage<AdditionalContract> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 59);

/**
 * 原価要素（レスポンス用）
 *
 * @generated from message api_proto.v1.CostElement
 */
export type CostElement = Message<"api_proto.v1.CostElement"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 cost_element_master_id = 2;
   */
  costElementMasterId: bigint;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string amount = 4;
   */
  amount: string;

  /**
   * @generated from field: int32 order_index = 5;
   */
  orderIndex: number;
};

/**
 * Describes the message api_proto.v1.CostElement.
 * Use `create(CostElementSchema)` to create a new message.
 */
export const CostElementSchema: GenMessage<CostElement> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 60);

/**
 * 原価要素（リクエスト用）
 *
 * @generated from message api_proto.v1.CostElementRequest
 */
export type CostElementRequest = Message<"api_proto.v1.CostElementRequest"> & {
  /**
   * @generated from oneof api_proto.v1.CostElementRequest.element_source
   */
  elementSource: {
    /**
     * @generated from field: int64 cost_element_master_id = 1;
     */
    value: bigint;
    case: "costElementMasterId";
  } | {
    /**
     * @generated from field: string new_element_name = 2;
     */
    value: string;
    case: "newElementName";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string amount = 3;
   */
  amount: string;

  /**
   * @generated from field: int32 order_index = 4;
   */
  orderIndex: number;
};

/**
 * Describes the message api_proto.v1.CostElementRequest.
 * Use `create(CostElementRequestSchema)` to create a new message.
 */
export const CostElementRequestSchema: GenMessage<CostElementRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 61);

/**
 * 追加工事契約（リクエスト用）
 *
 * @generated from message api_proto.v1.AdditionalContractRequest
 */
export type AdditionalContractRequest = Message<"api_proto.v1.AdditionalContractRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int64 company_staff_id = 2;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp contract_date = 3;
   */
  contractDate?: Timestamp;

  /**
   * @generated from field: repeated string construction_content = 4;
   */
  constructionContent: string[];

  /**
   * @generated from field: string construction_content_other = 5;
   */
  constructionContentOther: string;

  /**
   * @generated from field: string contract_memo = 6;
   */
  contractMemo: string;

  /**
   * @generated from field: string sales_amount = 7;
   */
  salesAmount: string;

  /**
   * @generated from field: string advance_payment = 8;
   */
  advancePayment: string;

  /**
   * @generated from field: string balance_payment = 9;
   */
  balancePayment: string;

  /**
   * @generated from field: repeated api_proto.v1.CostElementRequest cost_elements = 10;
   */
  costElements: CostElementRequest[];
};

/**
 * Describes the message api_proto.v1.AdditionalContractRequest.
 * Use `create(AdditionalContractRequestSchema)` to create a new message.
 */
export const AdditionalContractRequestSchema: GenMessage<AdditionalContractRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 62);

/**
 * 追加工事契約作成
 *
 * @generated from message api_proto.v1.CreateAdditionalContractRequest
 */
export type CreateAdditionalContractRequest = Message<"api_proto.v1.CreateAdditionalContractRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: api_proto.v1.AdditionalContractRequest additional_contract = 2;
   */
  additionalContract?: AdditionalContractRequest;
};

/**
 * Describes the message api_proto.v1.CreateAdditionalContractRequest.
 * Use `create(CreateAdditionalContractRequestSchema)` to create a new message.
 */
export const CreateAdditionalContractRequestSchema: GenMessage<CreateAdditionalContractRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 63);

/**
 * @generated from message api_proto.v1.CreateAdditionalContractResponse
 */
export type CreateAdditionalContractResponse = Message<"api_proto.v1.CreateAdditionalContractResponse"> & {
  /**
   * @generated from field: api_proto.v1.AdditionalContract additional_contract = 1;
   */
  additionalContract?: AdditionalContract;
};

/**
 * Describes the message api_proto.v1.CreateAdditionalContractResponse.
 * Use `create(CreateAdditionalContractResponseSchema)` to create a new message.
 */
export const CreateAdditionalContractResponseSchema: GenMessage<CreateAdditionalContractResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 64);

/**
 * 追加工事契約更新
 *
 * @generated from message api_proto.v1.UpdateAdditionalContractRequest
 */
export type UpdateAdditionalContractRequest = Message<"api_proto.v1.UpdateAdditionalContractRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: api_proto.v1.AdditionalContractRequest additional_contract = 2;
   */
  additionalContract?: AdditionalContractRequest;
};

/**
 * Describes the message api_proto.v1.UpdateAdditionalContractRequest.
 * Use `create(UpdateAdditionalContractRequestSchema)` to create a new message.
 */
export const UpdateAdditionalContractRequestSchema: GenMessage<UpdateAdditionalContractRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 65);

/**
 * @generated from message api_proto.v1.UpdateAdditionalContractResponse
 */
export type UpdateAdditionalContractResponse = Message<"api_proto.v1.UpdateAdditionalContractResponse"> & {
  /**
   * @generated from field: api_proto.v1.AdditionalContract additional_contract = 1;
   */
  additionalContract?: AdditionalContract;
};

/**
 * Describes the message api_proto.v1.UpdateAdditionalContractResponse.
 * Use `create(UpdateAdditionalContractResponseSchema)` to create a new message.
 */
export const UpdateAdditionalContractResponseSchema: GenMessage<UpdateAdditionalContractResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 66);

/**
 * 追加工事契約削除
 *
 * @generated from message api_proto.v1.DeleteAdditionalContractRequest
 */
export type DeleteAdditionalContractRequest = Message<"api_proto.v1.DeleteAdditionalContractRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteAdditionalContractRequest.
 * Use `create(DeleteAdditionalContractRequestSchema)` to create a new message.
 */
export const DeleteAdditionalContractRequestSchema: GenMessage<DeleteAdditionalContractRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 67);

/**
 * @generated from message api_proto.v1.DeleteAdditionalContractResponse
 */
export type DeleteAdditionalContractResponse = Message<"api_proto.v1.DeleteAdditionalContractResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message api_proto.v1.DeleteAdditionalContractResponse.
 * Use `create(DeleteAdditionalContractResponseSchema)` to create a new message.
 */
export const DeleteAdditionalContractResponseSchema: GenMessage<DeleteAdditionalContractResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal, 68);

/**
 * @generated from enum api_proto.v1.DealStatus
 */
export enum DealStatus {
  /**
   * 通常（statusとしては通常は使用しない
   *
   * @generated from enum value: DEAL_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 初期対応
   *
   * @generated from enum value: DEAL_STATUS_INITIAL_RESPONSE = 1 [deprecated = true];
   * @deprecated
   */
  INITIAL_RESPONSE = 1,

  /**
   * 見積り
   *
   * @generated from enum value: DEAL_STATUS_ESTIMATE = 2;
   */
  ESTIMATE = 2,

  /**
   * 契約
   *
   * @generated from enum value: DEAL_STATUS_CONTRACT = 3;
   */
  CONTRACT = 3,

  /**
   * 着工
   *
   * @generated from enum value: DEAL_STATUS_CONSTRUCTION = 4;
   */
  CONSTRUCTION = 4,

  /**
   * 請求
   *
   * @generated from enum value: DEAL_STATUS_BILLING = 5;
   */
  BILLING = 5,

  /**
   * 完工
   *
   * @generated from enum value: DEAL_STATUS_COMPLETE = 6;
   */
  COMPLETE = 6,

  /**
   * 見込みなし
   *
   * @generated from enum value: DEAL_STATUS_NO_PROSPECT = 7;
   */
  NO_PROSPECT = 7,

  /**
   * 失注
   *
   * @generated from enum value: DEAL_STATUS_LOST = 8;
   */
  LOST = 8,

  /**
   * 入金
   *
   * @generated from enum value: DEAL_STATUS_PAYMENT = 9;
   */
  PAYMENT = 9,

  /**
   * 問合せ
   *
   * @generated from enum value: DEAL_STATUS_INQUIRY = 10;
   */
  INQUIRY = 10,

  /**
   * 現調
   *
   * @generated from enum value: DEAL_STATUS_SURVEY = 11;
   */
  SURVEY = 11,
}

/**
 * Describes the enum api_proto.v1.DealStatus.
 */
export const DealStatusSchema: GenEnum<DealStatus> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_deal, 0);

/**
 * 案件の作成経路
 *
 * @generated from enum api_proto.v1.DealCreationSource
 */
export enum DealCreationSource {
  /**
   * 未指定（経路判定で抜けた場合、基本的に生じない）
   *
   * @generated from enum value: DEAL_CREATION_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 通常の詳細作成
   *
   * @generated from enum value: DEAL_CREATION_SOURCE_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * 簡易作成
   *
   * @generated from enum value: DEAL_CREATION_SOURCE_SIMPLE = 2;
   */
  SIMPLE = 2,

  /**
   * 見積書から作成
   *
   * @generated from enum value: DEAL_CREATION_SOURCE_QUOTATION = 3;
   */
  QUOTATION = 3,

  /**
   * 請求書から作成
   *
   * @generated from enum value: DEAL_CREATION_SOURCE_INVOICE = 4;
   */
  INVOICE = 4,

  /**
   * CSVインポートから作成
   *
   * @generated from enum value: DEAL_CREATION_SOURCE_CSV = 5;
   */
  CSV = 5,

  /**
   * AIカラーシミュレーションから作成
   *
   * @generated from enum value: DEAL_CREATION_SOURCE_AI_COLOR_SIMULATION = 6;
   */
  AI_COLOR_SIMULATION = 6,

  /**
   * 外部システム連携（SFTP自動取込）から作成
   *
   * @generated from enum value: DEAL_CREATION_SOURCE_EXTERNAL_IMPORT = 7;
   */
  EXTERNAL_IMPORT = 7,

  /**
   * 現地調査報告書の作成画面から作成（決定 63）
   *
   * @generated from enum value: DEAL_CREATION_SOURCE_SURVEY_REPORT = 8;
   */
  SURVEY_REPORT = 8,

  /**
   * 施工事例記事の作成画面から作成（決定 63）
   *
   * @generated from enum value: DEAL_CREATION_SOURCE_CASE_STUDY = 9;
   */
  CASE_STUDY = 9,
}

/**
 * Describes the enum api_proto.v1.DealCreationSource.
 */
export const DealCreationSourceSchema: GenEnum<DealCreationSource> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_deal, 1);

/**
 * @generated from enum api_proto.v1.DealSortKey
 */
export enum DealSortKey {
  /**
   * deal_form_valuesで扱えないものはenumで定義
   *
   * @generated from enum value: DEAL_SORT_KEY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEAL_SORT_KEY_ID = 1;
   */
  ID = 1,

  /**
   * @generated from enum value: DEAL_SORT_KEY_NAME = 2;
   */
  NAME = 2,

  /**
   * @generated from enum value: DEAL_SORT_KEY_STATUS = 3;
   */
  STATUS = 3,

  /**
   * @generated from enum value: DEAL_SORT_KEY_STAFF_NAME = 4;
   */
  STAFF_NAME = 4,

  /**
   * @generated from enum value: DEAL_SORT_KEY_CUSTOMER_NAME = 5;
   */
  CUSTOMER_NAME = 5,

  /**
   * @generated from enum value: DEAL_SORT_KEY_MINIMUM_ADDRESS = 6;
   */
  MINIMUM_ADDRESS = 6,

  /**
   * @generated from enum value: DEAL_SORT_KEY_APP_UPDATED = 7;
   */
  APP_UPDATED = 7,

  /**
   * @generated from enum value: DEAL_SORT_KEY_REGISTRATION_DATE = 8;
   */
  REGISTRATION_DATE = 8,

  /**
   * @generated from enum value: DEAL_SORT_KEY_EXTERNAL_SYSTEM_ID = 9;
   */
  EXTERNAL_SYSTEM_ID = 9,
}

/**
 * Describes the enum api_proto.v1.DealSortKey.
 */
export const DealSortKeySchema: GenEnum<DealSortKey> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_deal, 2);

/**
 * フロントのみで使用
 *
 * @generated from enum api_proto.v1.DealListType
 */
export enum DealListType {
  /**
   * @generated from enum value: DEAL_LIST_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 提案中
   *
   * @generated from enum value: DEAL_LIST_TYPE_PROPOSAL = 1;
   */
  PROPOSAL = 1,

  /**
   * 初期対応中
   *
   * @generated from enum value: DEAL_LIST_TYPE_PROGRESS = 2;
   */
  PROGRESS = 2,

  /**
   * 工事中
   *
   * @generated from enum value: DEAL_LIST_TYPE_CONSTRUCTION = 3;
   */
  CONSTRUCTION = 3,

  /**
   * 要請求
   *
   * @generated from enum value: DEAL_LIST_TYPE_BILLING = 4;
   */
  BILLING = 4,

  /**
   * 要入金確認
   *
   * @generated from enum value: DEAL_LIST_TYPE_DEPOSIT_REQUIRED = 5;
   */
  DEPOSIT_REQUIRED = 5,

  /**
   * 完了案件一覧
   *
   * @generated from enum value: DEAL_LIST_TYPE_COMPLETE = 6;
   */
  COMPLETE = 6,

  /**
   * 失注案件一覧
   *
   * @generated from enum value: DEAL_LIST_TYPE_LOST = 7;
   */
  LOST = 7,

  /**
   * 着工中
   *
   * @generated from enum value: DEAL_LIST_TYPE_BEFORE_CONSTRUCTION = 8;
   */
  BEFORE_CONSTRUCTION = 8,
}

/**
 * Describes the enum api_proto.v1.DealListType.
 */
export const DealListTypeSchema: GenEnum<DealListType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_deal, 3);

/**
 * @generated from enum api_proto.v1.DealListMatchedMemoSource
 */
export enum DealListMatchedMemoSource {
  /**
   * @generated from enum value: DEAL_LIST_MATCHED_MEMO_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 案件対応メモ
   *
   * @generated from enum value: DEAL_LIST_MATCHED_MEMO_SOURCE_DEAL = 1;
   */
  DEAL = 1,

  /**
   * 顧客対応メモ
   *
   * @generated from enum value: DEAL_LIST_MATCHED_MEMO_SOURCE_CUSTOMER = 2;
   */
  CUSTOMER = 2,
}

/**
 * Describes the enum api_proto.v1.DealListMatchedMemoSource.
 */
export const DealListMatchedMemoSourceSchema: GenEnum<DealListMatchedMemoSource> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_deal, 4);

